
export default {
    name: 'BaseLayouts',
    data() {
        return {
            loading: true,
        }
    },
    computed: {},
    watch: {
        $route: {
            handler(val) {
                if (val.path == '/') {
                    this.renderLoading()
                } else {
                    this.loading = false
                }
            },
            immediate: true,
            deep: true,
        },
    },
    created() {
        this.renderLoading()
    },
    methods: {
        renderLoading() {
            this.loading = true
            const timer = setTimeout(() => {
                this.loading = false
            }, 1400)

            this.$once('hook:beforeDestroy', () => {
                clearInterval(timer)
            })
        },
    },
}
